import { render, staticRenderFns } from "./HighlightsBadge.vue?vue&type=template&id=a7843324&lang=html&"
import script from "./HighlightsBadge.vue?vue&type=script&lang=js&"
export * from "./HighlightsBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports